import {client} from '@core/GraphQLProvider';
import {GetCustomer, AddPayment, GetSelectedPaymentOption, SetSelectedPaymentOption} from './query.graphql';
import {addPaymentUpdateStrategy} from './mutations';

if ( process.env.MOCK_API == 1 ) {
    require( './mocks' );
}

const CustomerService = {
    async getCustomer ( withOptions ) {
        const resp = await client.query( {
            query: GetCustomer,
            variables: {
                ...withOptions
            }
        } );

        return resp.data.customer;
    },

    async addPayment ( input ) {
        const resp = await client.mutate( {
            input,
            mutation: AddPayment,
            update: addPaymentUpdateStrategy
        } );

        return resp.data.addPayment;
    },

    getSelectedPaymentOption () {
        return client.query( {
            fetchPolicy: 'cache-only',
            query: GetSelectedPaymentOption
        } );
    },

    setSelectedPaymentOption ( input ) {
        return client.mutate( {
            mutation: SetSelectedPaymentOption,
            variables: {input}
        } );
    }

};

export default CustomerService;
